module.exports = __webpack_public_path__ + "static/payor-contracting-7f271deff45ef259742486e4f75c685c.svg";